import { render, staticRenderFns } from "./TitleSlicerBarIcon.vue?vue&type=template&id=7896908e&scoped=true&"
import script from "./TitleSlicerBarIcon.vue?vue&type=script&lang=js&"
export * from "./TitleSlicerBarIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7896908e",
  null
  
)

export default component.exports